import { useMemo, useState } from "react";
import {
  previewManufacturingNamedVariantApplication,
  type NamedVariantApplicationSummary,
  type NamedVariantConfirmStatus,
} from "@/lib/manufacturing/namedVariantsClient";
import type { NamedVariantPreviewModalModel } from "./ManufacturingNamedVariantPreviewModal";

export function useNamedVariantApplicationPreview(
  applications: readonly NamedVariantApplicationSummary[],
) {
  const [previewBusy, setPreviewBusy] = useState(false);
  const [previewError, setPreviewError] = useState<string | null>(null);
  const [previewModel, setPreviewModel] = useState<NamedVariantPreviewModalModel | null>(null);

  const assignedByParentId = useMemo(() => {
    const map = new Map<string, NamedVariantConfirmStatus>();
    for (const app of applications) {
      map.set(app.parent_recipe_id, app.confirm_status);
    }
    return map;
  }, [applications]);

  async function openPreview(applicationId: string) {
    const app = applications.find((a) => a.id === applicationId);
    setPreviewBusy(true);
    setPreviewError(null);
    setPreviewModel(null);
    const r = await previewManufacturingNamedVariantApplication(applicationId);
    setPreviewBusy(false);
    if (!r.ok) {
      setPreviewError(r.error);
      return;
    }
    setPreviewModel({
      applicationId,
      title: app ? `${app.parent_recipe_code} — ${app.parent_recipe_name}` : applicationId,
      lines: r.data.lines,
      warnings: r.data.warnings,
    });
  }

  function closePreview() {
    setPreviewModel(null);
    setPreviewError(null);
    setPreviewBusy(false);
  }

  return {
    previewBusy,
    previewError,
    previewModel,
    assignedByParentId,
    openPreview,
    closePreview,
  };
}
